<template>
  <!-- Vertically centered scrollable modal -->
  <form label-width="0px" class="demo-ruleForm needs-validation-update-twofactauth" novalidate>
    <div class="modal fade" id="updateTwoFactAuthModal" tabindex="-1" role="dialog" aria-labelledby="updateTwoFactAuthModal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">{{$t('TwiceVerification.bindAuthenticator')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h5>1.{{$t('TwiceVerification.SetVerificationCodeStep2')}}</h5>
            <div class="qrcode"><img v-bind:src="qrcodeURL" /></div>
            <div class="ml-3">{{$t('TwiceVerification.UrlCopy')}}
              <a href="javascript:void(0);" @click="copySecret" :title="$t('TwiceVerification.Copy')"><i class="fa fa-clone" aria-hidden="true"></i></a>
            </div>
            <input id="inputCom" class="form-control ml-3" style="width:auto" :value="secret" readonly>
            <div class="pt-3 pb-3">
              <h5>2.{{$t('TwiceVerification.SetVerificationCodeStep3')}}</h5>
            </div>
            <h5 class="col-8 col-md-6">{{$t('TwiceVerification.verificationCode')}}<input v-model="verificationCode" class="form-control" required id="verificationCodeStep1">
              <div class="invalid-feedback">
                {{$t('TwiceVerification.verificationCodeRequired')}}
              </div>
            </h5>
          </div>
          <div class="modal-footer pt-5 pb-3">
            <div class="col-6">
              <button type="button" class="btn btn-lg btn-outline-secondary" data-dismiss="modal">{{$t('modal.modalCancel')}}
              </button>
            </div>
            <div class="col-6 text-right">
              <button class="btn btn-lg btn-primary" @click="change">{{$t('modal.modalChange')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<style />

<script type="text/javascript">
import { NmsClient, RestCfg } from '../../scripts/AllExport'
import QRCode from 'qrcode'
let updateTwoFactAuthReqType = 'user-setting-twofactauth'
export default {
  data: function () {
    return {
      verificationCode: '',
      qrcodeURL: '',
      secret: ''
    }
  },
  mounted() {
    $('#updateTwoFactAuthModal').on('hidden.bs.modal', (event) => {
      this.qrcodeURL = ''
      this.verificationCode = ''
      this.secret = ''
      if ($('.needs-validation-update-twofactauth')[0] !== undefined) {
        $('.needs-validation-update-twofactauth')[0].classList.remove('was-validated')
      }
    })

    $('#updateTwoFactAuthModal').on('shown.bs.modal', (event) => {
      NmsClient.send(
        RestCfg.POST,
        {
          'reqType': updateTwoFactAuthReqType,
          'step': 1
        },
        (response) => {
          let result = response.resultInfo
          this.secret = result.secret
          QRCode.toDataURL(result.uri)
            .then(url => {
              this.qrcodeURL = url
            })
            .catch(err => {
              console.error(err)
            })
        },
        null
      )
    })
  },
  methods: {
    change() {
      let form = $('.needs-validation-update-twofactauth')[0]

      form.onsubmit = (event) => {
        event.preventDefault()
        if (form.checkValidity()) {
          NmsClient.send(
            RestCfg.POST,
            {
              'reqType': updateTwoFactAuthReqType,
              'verificationCode': this.verificationCode,
              'step': 2
            },
            this.updateTwoFactAuthResult,
            null
          )
        }
        form.classList.add('was-validated')
      }
    },
    updateTwoFactAuthResult(response) {
      this.$alert('Update succeeded', 'Message', {
        confirmButtonText: 'OK',
        lockScroll: false,
        closeOnClickModal: true,
        callback: action => {
          $('#updateTwoFactAuthModal').modal('hide')
        }
      })
    },
    copySecret() {
      let inputCom = document.getElementById('inputCom')
      inputCom.select()
      document.execCommand('copy')
      this.$message.success(this.$t('TwiceVerification.CopySuccess'), 0)
    }
  }
}
</script>
<style scoped>
.modal-body{
  height:553px;
}
.qrcode{
  height:212px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/update-twofactauth.vue